import type { CompleteShippingAgencyTransferPayload } from "@services/shipping-agency-transfer/types";
import { completeShippingAgencyTransferById } from "@services/shippingAgencyTransferApi";
import { useMutation } from "@tanstack/react-query";
import { runTransaction } from "@telemetry/runTransaction";

const getCompleteTransferAction = (payload: CompleteShippingAgencyTransferPayload): string => {
  if (payload.status.includes("APPROVED")) return "approve_shipping_agency_transfer";
  if (payload.status.includes("REJECTED")) return "reject_shipping_agency_transfer";
  return "complete_shipping_agency_transfer";
};

export const useCompleteShippingAgencyTransfer = ({
  handleSuccess,
  handleError,
}: {
  handleSuccess: () => void;
  handleError: (error: Error) => void;
}) => {
  const completeTransferMutation = useMutation({
    mutationFn: (variables: Parameters<typeof completeShippingAgencyTransferById>[0]) =>
      runTransaction(
        {
          module: "vessel_call",
          screen: "ShippingAgencyTransfer",
          action: getCompleteTransferAction(variables.payload),
          entityType: "shipping_agency_transfer",
        },
        (transactionId) =>
          completeShippingAgencyTransferById({
            ...variables,
            ...(transactionId ? { transactionId } : {}),
          }),
      ),
    onSuccess: () => handleSuccess(),
    onError: (error: Error) => handleError(error),
  });

  const completeShippingAgencyTransfer = async ({
    id,
    service,
    payload,
  }: {
    id: string;
    service: string;
    payload: CompleteShippingAgencyTransferPayload;
  }) => {
    completeTransferMutation.mutate({
      id,
      service,
      payload,
    });
  };

  return {
    completeShippingAgencyTransfer,
  };
};
